import axios from "axios";

export type PlaybackDenialReason = "authentication_required" | "membership_required" | "membership_paused" | "not_released";
export type VideoPlaybackDecision =
    | { video_id: number; allowed: true; reason: "allowed"; url: string }
    | { video_id: number; allowed: false; reason: PlaybackDenialReason; available_at?: string };

const denialReasons: PlaybackDenialReason[] = [
    "authentication_required", "membership_required", "membership_paused", "not_released",
];

export async function GetVideoPlayback(
    videoId: number,
    accessToken: string | null,
    signal: AbortSignal
): Promise<VideoPlaybackDecision> {
    const base = (process.env.REACT_APP_WEB_API_URL ?? "").replace(/\/+$/, "");
    if (!base) throw new Error("REACT_APP_WEB_API_URL is not set.");
    try {
        const response = await axios.get(`${base}/v2/videos/${videoId}/playback`, {
            signal,
            timeout: 15000,
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
        });
        const data = response.data;
        if (data?.video_id !== videoId || data?.allowed !== true || data?.reason !== "allowed" ||
            typeof data?.url !== "string" || !/^https?:\/\//i.test(data.url)) {
            throw new Error("Invalid playback authorization response.");
        }
        return { video_id: videoId, allowed: true, reason: "allowed", url: data.url };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const data = error.response?.data;
            if ([401, 403].includes(error.response?.status ?? 0) && data?.video_id === videoId &&
                data?.allowed === false && denialReasons.includes(data.reason) && !data.url) {
                return {
                    video_id: videoId, allowed: false, reason: data.reason,
                    ...(typeof data.available_at === "string" ? { available_at: data.available_at } : {}),
                };
            }
        }
        throw error;
    }
}
